import $ from 'jquery';
import videoComponent from '../video/videoComponent';

const whatsLifeInsurance = {
    variables:{
        whatIsLifeInsurance__video : '.whatIsLifeInsurance__video',
        url: window.location.href,
    },

    methods:{
        init: function(){
           videoComponent.methods.registerVideo(whatsLifeInsurance.variables.whatIsLifeInsurance__video);
        },

         DownloadButtonClickHandler : function () {
             $(".whatIsLifeInsurance__section__cta").on('click', function(){
                let title = $(this).closest('.whatIsLifeInsurance__section').find('.whatIsLifeInsurance__section__title').text().trim();
                let buttonText = $(this).text().replace(/\s+/g, ' ').trim().replace(/\s*\(?opens in a new tab\)?\s*/i, '');
                let name = $(this)[0].getAttribute('href');
                let obj = whatsLifeInsurance.methods.dataLayerObj(title,buttonText);
                let flag = document.querySelector("input[name='pageType']") != null && (document.querySelector("input[name='pageType']").value == 'Product' || document.querySelector("input[name='pageType']").value == 'Category Page') ? true : false;
                if(!name.includes('.pdf'))
                    createDataLayer('buttonClick', obj);
                else if(name.includes('.pdf') && flag)
                    createDataLayer('Download_Product', obj);
                else 
                    createDataLayer('Download_NonProduct', obj);
             })
            },

        dataLayerObj : function(el,e) {
                    var obj = {
                        'articleName' : "",
                        'blogCategory' : "",
                        'blogPageCategory' : "",
                        'buttonText' : e ? e : "",
                        'pageSection' : el ? el : "",
                        'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? whatsLifeInsurance.variables.url.includes("blog") ? "Blogs" : whatsLifeInsurance.variables.url.substring(whatsLifeInsurance.variables.url.indexOf(".com/"), whatsLifeInsurance.variables.url.lastIndexOf('/')  === ".com") && !whatsLifeInsurance.variables.url.substring(whatsLifeInsurance.variables.url.indexOf(".com/"), whatsLifeInsurance.variables.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                        'planOption' : "",
                        'productCategory' : "",
                        'productName' : "",
                        'question' : "",
                        'searchTerm' : "",
                        'videoTitle' : "",
                        'bannerName' : "",
                        'bannerType' : ""

                    }
                    return obj;
                }
    }
};

$(document).ready(function () {
whatsLifeInsurance.methods.DownloadButtonClickHandler();
});

$(()=>{
if($('.whatIsLifeInsurance__section').length > 0){
    whatsLifeInsurance.methods.init();
}
});
